import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AddUnderscoreAndDash} from '../pipes/addUnderscore.pipe';
import {MomentDatePipe} from '../pipes/moment-date.pipe';
import {RemoveUnderscoreAndDashPipe} from '../pipes/removeUnderscore.pipe';
import {MatchValueDirective, NoWhitespaceDirective} from '../directives/common-form-validator.directive';
import {SanitizeHtmlPipe} from '../pipes/sanitize.pipe';
import {Sort} from '../pipes/sort.pipe';
import {NgxPaginationModule} from 'ngx-pagination';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import {RouterModule} from '@angular/router';
import { NumberFormater } from '../pipes/numberFormater.pipe';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {UserService} from "../../services/userService/user.service";
import {RestfulHttpService} from "../../services/httpService/service.service";
import {ApiService} from "../../services/api/api.service.";
import {UtilService} from "../services/utilService/util.service";
import {EventsService} from "../services/eventServices/event.service";
import {CacheService} from "../services/cacheService/cache.service";
import {NgSelectModule} from "@ng-select/ng-select";

@NgModule({
  declarations: [
    AddUnderscoreAndDash,
    MomentDatePipe,
    RemoveUnderscoreAndDashPipe,
    NumberFormater,
    NoWhitespaceDirective,
    MatchValueDirective,
    SanitizeHtmlPipe,
    Sort,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    PopoverModule.forRoot(),
    NgxPaginationModule,
    NgSelectModule,
    RouterModule
  ],
  providers: [
    UserService,
    RestfulHttpService,
    UtilService,
    EventsService,
    CacheService,
    ApiService],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    AddUnderscoreAndDash,
    MomentDatePipe,
    RemoveUnderscoreAndDashPipe,
    NumberFormater,
    NoWhitespaceDirective,
    NgxPaginationModule,
    TooltipModule,
    NgSelectModule,
    BsDropdownModule,
    BsDatepickerModule,
    PopoverModule
  ]
})
export class SharedModule { }
